import React from "react";
import { string, object } from "prop-types";
import "./Section.css";

const Section = ({ heading, children, style, className }) => {
  return (
    <div className={`section ${className ? className : ""}`} style={style}>
      {heading && (
        <div className="title">
          <h1>{heading}</h1>
        </div>
      )}
      <div className="section-content">{children}</div>
    </div>
  );
};

Section.porpTypes = {
  heading: string,
  className: string,
  style: object
};

export default Section;



// WEBPACK FOOTER //
// ./src/common/section/Section.js